/**
 * 巡检点位管理接口实现方法
 */

// 公共方法
import { setStoreApiDate } from '../utils'
const prefix = '/dseWeb'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 分页查询巡检点位
    async fetchGetInspectionPointPage({ commit, getters }, params) {
      const { getInspectionPointPage } = getters.getHttps
      const { data } = await getInspectionPointPage(params)
      return setStoreApiDate(data, commit)
    },
    // 新增或修改
    async fetchInsertOrUpdateInspectionPoint({ commit, getters }, params) {
      const { insertOrUpdateInspectionPoint } = getters.getHttps
      const { data } = await insertOrUpdateInspectionPoint(params)
      return setStoreApiDate(data, commit)
    },
    // 查询单个详情
    async fetchGetInspectionPointInfo({ commit, getters }, params) {
      const { getInspectionPointInfo } = getters.getHttps
      const { data } = await getInspectionPointInfo(params)
      return setStoreApiDate(data, commit)
    },
    // 删除
    async fetchDeleteInspectionPoint({ commit, getters }, params) {
      const { deleteInspectionPoint } = getters.getHttps
      const { data } = await deleteInspectionPoint(params)
      return setStoreApiDate(data, commit)
    },
    // 获取巡检点位二维码（返回 base64）
    async fetchGetInspectionPointQrCode({ commit, getters }, params) {
      const { getInspectionPointQrCode } = getters.getHttps
      const { data } = await getInspectionPointQrCode(params)
      return setStoreApiDate(data, commit)
    },
    // 导入巡检点位
    async fetchImportInspectionPoint({ commit, getters }, params) {
      const { batchImport } = getters.getHttps
      const { data } = await batchImport(params)
      return setStoreApiDate(data, commit)
    }
  }
}